<template>
  <div>
    <div class="bg-tile-500 text-white p-4">
      <vk-modal-close outside @click="modalClose()"></vk-modal-close>
      <div v-if="info" class="flex items-center">
        <div class="col-md-4">
          <div class="flex flex-col items-start justify-center">
            <span class="text-lg">#{{ login }}</span>
            <span class="text-xs">
              {{ info.Name }}
            </span>
          </div>
        </div>
        <div class="col-md-8">
          <ul class="meta-detail-info">
            <li>
              <b>Kayıt Tarihi</b>
              {{ info.Registration | formatDate }}
            </li>
            <li>
              <b>Hesap Türü</b>
              {{ type }}
            </li>
            <li>
              <b>Son başarılı giriş</b>
              {{ info.LastAccess | formatDate }}
            </li>
            <li>
              <b>Son şifre değişim tarihi</b>
              {{ info.LastPassChange | formatDate }}
            </li>

            <li>
              <b>Grup</b>
              {{ info.Group }}
            </li>

            <li>
              <b>Bakiye</b>
              {{ info.Balance }}
            </li>
          </ul>

          <div class="fix"></div>
        </div>
      </div>
    </div> 

    <vk-tabs>
      <vk-tabs-item title="Açık pozisyonlar">
        <Orders :login="login" :type="type" />
      </vk-tabs-item>
      <vk-tabs-item title="Bekleyen emirler">
        <PendingOrders :login="login" :type="type" />
      </vk-tabs-item>
      <vk-tabs-item title="Kapanmış pozisyonlar">
        <ClosedOrders :login="login" :type="type" />
      </vk-tabs-item>

      <vk-tabs-item title="Yatırılan paralar">
        <Deposits :login="login" :type="type" />
      </vk-tabs-item>
      <vk-tabs-item title="Para Çekim işlemleri">
        <Withdrawals :login="login" :type="type" />
      </vk-tabs-item>
    </vk-tabs>
  </div>
</template>

<script>
import Orders from "./Orders";
import Withdrawals from "./Withdrawals";
import Deposits from "./Deposits";
import EventBus from "../../../../components/Ui/EventBus";
import dateVue from "../../../../components/Ui/Search/date.vue";
import PendingOrders from "./PendingOrders.vue";
import ClosedOrders from "./ClosedOrders.vue";

export default {
  props: ["login", "type", "info"],
  components: {
    Orders,
    Withdrawals,
    datepicker: dateVue,
    Deposits,
    PendingOrders,
    ClosedOrders,
  },
  created() {},
  methods: {
    modalClose() {
      EventBus.$emit("modalClose", "true");
    },
    setDatepicker(eee) {
      console.log(eee);
    },
  },
};
</script>

<style>
.mx-datepicker-main {
}
.meta-detail-info li {
  display: inline-block;
  float: right;
  font-size: 15px;
  margin-left: 20px;
  border-left: 1px solid rgba(255, 255, 255, 0.22);
  padding-left: 20px;
}
.meta-detail-info {
  margin: 0px;
  padding: 0px;
  text-align: left;
}
.meta-detail-info b {
  display: Block;
  font-weight: 900;
  font-size: 10px;
}
</style>
